module.exports = __webpack_public_path__ + "media/categories/2031-9713675b.svg";